import React from 'react';
import { ActivityIndicator, Text, View } from 'react-native';

//= ========================================================================

const UploadLoadingIcon = ({
  fileName,

}) => {
  const myStyles = {
    container: {
      paddingVertical: 2,
      paddingHorizontal: 4,
      marginVertical: 33.2,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: '#f7fafc',
      border: 'solid 0.6px #f56565',
      borderRadius: 4,
      position: 'absolute',
      zIndex: 2,
      marginBottom: 10,
    },
    activeImage: {
      width: 24,
      height: 24,
    },
    text: {
      maxWidth: 104,
      fontSize: 12,
      paddingHorizontal: 6,
      color: '#f56565',
    },
  };

  return (
    <View style={myStyles.container}>
      <ActivityIndicator style={myStyles.activeImage} animating color="#f56565" size="small" />
      <Text numberOfLines={1} ellipsizeMode="tail" style={myStyles.text}>
        {fileName}
      </Text>
    </View>
  );
};
export default UploadLoadingIcon;
